import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'package-config',
    loadComponent: () =>
      import('./features/package-config/component').then(
        (m) => m.PackageConfigComponent,
      ),
  },
  {
    path: 'article-content',
    loadComponent: () =>
      import('./features/article-content/component').then(
        (m) => m.ArticleContentComponent,
      ),
  },
  {
    path: 'blog-info',
    loadComponent: () =>
      import('./features/blog/info/component').then((m) => m.BlogInfoComponent),
  },
  {
    path: 'employers',
    loadChildren: () =>
      import('./features/employers/routes').then((m) => m.routes),
  },
];
